module.exports = __webpack_public_path__ + "static/media/feature-icon.bc7673c8.png";